import { combineReducers } from 'redux';
import errorReducer from './errorReducer';
import authReducer from './authReducer';
import recordingReducer from './recordingReducer';

export default combineReducers({
    recording: recordingReducer,
    error: errorReducer,
    auth: authReducer
});